import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alignItems", "backgroundColor", "borderColor", "borderEndEndRadius", "borderEndStartRadius", "borderStyle", "borderWidth", "children", "justifyContent", "minBlockSize", "padding"];
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseContentControlWrapper = _ref => {
  let {
      alignItems = 'center',
      backgroundColor = 'fill-surface-default',
      borderColor = 'border-core-disabled',
      borderEndEndRadius = '100',
      borderEndStartRadius = '100',
      borderStyle = 'solid',
      borderWidth = '100',
      children,
      justifyContent = 'end',
      minBlockSize = '65px',
      padding = '200'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    alignItems: alignItems,
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderEndEndRadius: borderEndEndRadius,
    borderEndStartRadius: borderEndStartRadius,
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    justifyContent: justifyContent,
    minBlockSize: minBlockSize,
    padding: padding
  }, props, {
    children: children
  }));
};